if (!window.Element.prototype.getAttributeNames) {
  window.Element.prototype.getAttributeNames = function () {
    return Array.from(this.attributes).map(element => element.name)
  }
}
